import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'
import Button from '@mui/material/Button'
import MUIDataTable from "mui-datatables"
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useAuth } from '../../hooks/auth'
import MvmApi from '../../services/MvmApi'
import { useStyles } from './Style'

type Props = {
    reloadOnCLick?: any;
    getCounts?: any;
}

const VehiclesWatingNF: React.FC<Props> = (props) => {
    const classes = useStyles();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("EntryPlant");
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [mvmId, setMvmId] = React.useState(0);
    const { user } = useAuth();
    const { enqueueSnackbar } = useSnackbar();
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const { isLoading, isFetching, data, refetch } = useQuery('VehicleWatingNFList', async () => {
        props.getCounts();
        return await MvmApi.getVehicleWatingNFList(+user.company.plantID, user.userName);
    }, {
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: true,
        staleTime: 1000 * 360, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 1200, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    useEffect(() => {
        refetch();
    }, []);

    useEffect(() => {
        if (props.reloadOnCLick > 0) {
            refetch();
        }
    }, [props.reloadOnCLick]);

    const columns = [
        {
            name: 'mvmCode',
            label: t("mvmCode"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }

        },
        {
            name: 'vehiclePlateNumber',
            label: t("vehiclePlateNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'vehicleType',
            label: t("vehicleType"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            style: {},
            name: 'mvmId',
            label: ' ',
            innerWidth: 10,
            options: {
                setCellHeaderProps: () => ({
                    align: "center",
                    width: 260
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <Button style={{ height: "100%", width: 260, fontSize: "0.7rem", padding: "2px" }} variant="outlined"
                            onClick={() => handleDialogClickOpen(value)}>
                            Liberar veículo para saída do pátio
                        </Button>
                    )
                }
            },
        },
    ]

    const options = {
        textLabels: {
            body: {
                noMatch: _t('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: _t("next"),
                previous: _t("previous"),
                rowsPerPage: _t("rowsPerPage") + ":",
                displayRows: _t("of"),
            }
        }
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })

    const handleDialogClickOpen = (idMvm: number) => {
        setMvmId(idMvm);
        setDialogOpen(true);
    };

    const handleDialogClickClose = () => {
        resetFormAuthorize()
        setDialogOpen(false);
    };

    const resetFormAuthorize = () => {
        setMvmId(0);
    }

    const handleConfirmation = async () => {
        setDialogOpen(false);
        setOpenBackdrop(true);
        MvmApi.authorizeVehicleReleasePlant(mvmId)
            .then(async () => {
                enqueueSnackbar(t("autorizedReleasePlantSuccess"), { variant: 'success' });
                setOpenBackdrop(false);
                // props.getCounts();
                resetFormAuthorize()
                refetch();
            }).catch(() => {
                enqueueSnackbar(t("autorizedReleasePlantError"), { variant: 'error' });
                // setOpenBackdrop(false);
                // props.getCounts();
                resetFormAuthorize()
                refetch();
            });

    };

    return (
        <>
            <Backdrop className={classes.backdrop} open={openBackdrop || isLoading || isFetching}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Dialog
                open={dialogOpen}
                onClose={handleDialogClickClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t("authorize")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("authorizeReleasePlantQuestion")}
                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmation} autoFocus>{"Liberar"}</Button>
                </DialogActions>
            </Dialog>

            {
                <MuiThemeProvider theme={myTheme}>
                    <MUIDataTable
                        title=""
                        data={data != null && data.length > 0 ? data : []}
                        columns={columns}
                        options={{
                            ...options,
                            serverSide: true,
                            pagination: false,
                            sort: false,
                            selectToolbarPlacement: "none",
                            filter: false,
                            search: false,
                            download: false,
                            print: false,
                            viewColumns: false,
                            selectableRows: 'none',
                        }}
                    />
                </MuiThemeProvider>
            }
        </>
    )
}
export default VehiclesWatingNF;
